import * as React from "react";

export interface LongNameOptionComponentProps {
    name: string;
    value: string;
}

export const LongNameOptionComponent = (props: LongNameOptionComponentProps) => (
    <option value={props.value} title={props.name}>
        {props.name.length > 20 ? props.name.slice(0, 20) + "..." : props.name}
    </option>
);
